import { Link } from "react-router-dom";

const aiBlocks = [
  {
    question: "What does an architect do?",
    answer:
      "An architect designs buildings, prepares the construction documents required for permits, coordinates structural and mechanical engineers, and oversees construction to ensure the design is built correctly. At Studio 1323, we manage every phase — from the first concept sketch through final occupancy — across residential, multi-family, and hospitality project types in Santa Monica and Los Angeles.",
    icon: "ri-pencil-ruler-2-line",
    link: "/process",
    linkLabel: "See Our Process",
  },
  {
    question: "What architectural services does Studio 1323 provide?",
    answer:
      "Studio 1323 provides full-service architectural design including custom residential homes, multi-family apartment and townhome development, boutique hotel and restaurant design, and whole-home renovation. Services include concept design, design development, construction documents, permitting support, and construction administration for projects across Santa Monica and greater Los Angeles.",
    icon: "ri-list-check-3",
    link: "/services",
    linkLabel: "View All Services",
  },
  {
    question: "How does the architectural design process work?",
    answer:
      "The process begins with a complimentary consultation to understand your project, site, and goals. We then move through five phases: Discovery, Concept Design, Design Development, Permitting, and Construction. Each phase has clear deliverables and client review points. Most residential projects take 12–24 months from design through construction completion.",
    icon: "ri-route-line",
    link: "/process",
    linkLabel: "Full Process Breakdown",
  },
  {
    question: "Who is Studio 1323 best for?",
    answer:
      "Studio 1323 is best suited for homeowners seeking a custom-designed residence, real estate developers building multi-family or mixed-use projects, and hospitality operators designing hotels, restaurants, or wellness spaces. We work with clients who value design quality, expect a collaborative partner, and are pursuing projects in the Santa Monica and Los Angeles market.",
    icon: "ri-user-star-line",
    link: "/about",
    linkLabel: "About the Firm",
  },
];

export default function AISearchContent() {
  return (
    <section className="py-20 lg:py-28 px-8 lg:px-14 bg-arch-cream border-t border-arch-border">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-3">Architecture Explained</p>
            <h2 className="font-serif text-4xl text-arch-charcoal font-light leading-tight">
              Understanding<br />
              <em>what we do</em>
            </h2>
          </div>
          <p className="text-arch-gray text-sm font-light max-w-xs leading-relaxed">
            Clear answers to the questions clients ask most — about process, services, and who we work with.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {aiBlocks.map((block) => (
            <div
              key={block.question}
              className="bg-white border border-arch-border rounded-lg p-7 flex flex-col gap-4"
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center border border-arch-border rounded-md flex-shrink-0">
                  <i className={`${block.icon} text-arch-charcoal text-base`} />
                </div>
                <h3 className="text-arch-charcoal text-sm font-semibold leading-snug">
                  {block.question}
                </h3>
              </div>
              <p className="text-arch-gray text-sm font-light leading-relaxed flex-1">
                {block.answer}
              </p>
              <Link
                to={block.link}
                className="inline-flex items-center gap-1.5 text-arch-charcoal text-xs tracking-[0.12em] uppercase font-medium border-b border-arch-charcoal pb-0.5 self-start hover:text-arch-gray hover:border-arch-gray transition-colors cursor-pointer"
              >
                {block.linkLabel}
                <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
